//header prop is required and needs to be unique or else there might be errors with multiple carousel
import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import {
	Button,
	Card,
	Header,
	Icon,
	Image
} from 'semantic-ui-react'
import {Link, navigate} from 'gatsby'
import {
		CarouselProvider,
		Slide,
		Slider,
		ButtonBack,
		ButtonNext,
} from "pure-react-carousel";
import 'pure-react-carousel/dist/react-carousel.es.css';
import * as styles from './styles/carousel.module.css'
import {
	mobileMaxWidth,
	resizeTimer,
	tabletMaxWidth
} from '../../globalVar'

import * as contentpagestyles from "../../templates/styles/contentpage.module.css"
import ImageHolder from '../ImageHolder';

const Negosyo = require('../../../lib/negosyo');
const Logger = require('../../../lib/logger');
const StylingTools = require('../../../lib/stylingTools');

class Carousel extends Component {
	state= {
		shown: this.props.initialShown || 5,
		height: ( (this.props.type==="category" || this.props.type==="business") && !(this.props.isItemsLoading) ) ? 1.2:1.4,
		timeOut:undefined, // For window resize events
		reqAnimationFrameTimeout:undefined, // For requestAnimationFrame
		windowWidth:undefined,
		userExclusiveList: this.props.exclusivelist?this.props.exclusivelist:[]
	}

	constructor (props) {
		super(props)
		this.mouseMovement = React.createRef();
		this.mouseMovement.current = { startX: 0, startY: 0, endX: 0, endY: 0 };
		this.carouselRef = React.createRef();
	}
	
	componentDidMount() {
		this._isMounted = true;
		this.handler();
		window.addEventListener('resize', this.resizeConsolidator)

		if (this.props.type === "product" && this.state.userExclusiveList.length<1) {
			Negosyo.getCurrentUserDetails()
			.then((user) => {
				if (user.hasOwnProperty("username")) {
					Negosyo.getUserProfile(user.username, "exclusivelist")
					.then((userProfile) => {
						if (userProfile.status === "OK") {
							this.setState({
								userExclusiveList: userProfile.data
							})
						};
					}).catch((err) => {
						Logger.log(err);
					})
				}
			}).catch((err) => {
				Logger.log(err);
			})
		}

		this.addDataLayer()
	}

	resizeConsolidator = () => {
		clearTimeout(this.state.timeOut)
		const temp = setTimeout(this.handler, resizeTimer);
		if(this._isMounted) {
			this.setState({
				timeOut:temp
			})
		}

	}

	addDataLayer = () => {
		const {
			type,
			isItemsLoading,
			items,
			listName
		} = this.props
		if(!isItemsLoading) { //isItemsLoading=variable for checking if the items are still Loading, need to rename this or flip the values
			if(type==="product") {
				const dataLayerList = items.map(({name, price, meta, sku}, index)=>{
					return {
						'name': name,
						'id':sku ?? meta.sku,
						'price': parseFloat(price ?? meta.display_price.with_tax.amount),
						'list': listName,
						'position':index+1,
						'item_id': sku ?? meta.sku,
						'item_name': name,
						'currency': "PHP",
						'index': index+1,
						'item_list_id': listName,
						'item_list_name': listName,
						'quantity': 1
					}
				})
				window.dataLayer = window.dataLayer || [];
				window.dataLayer.push({
					'event': 'productList',
					'ecommerce': {
						'impressions': dataLayerList
					}
				});
			}
		}
	}

	/* a function that uses both requestAnimationFrame and setTimeout to make sure the paint is done
	 * before calling the function to resize the cards and carousel Provider
	 * setTimeout to clear the callstack and requestAnimationFrame to make sure the dom is rendered
	 * before doing the resizing of cards/carousel.
	 */
	reqAnimationFrame = (time) => {
		clearTimeout(this.state.reqAnimationFrameTimeout)
		const callback = this.findCards
		const timeOut = setTimeout( () => {
			window.requestAnimationFrame(callback)
		},time)
		//clears the Timeout to make less repaints/re render for the screen
		if(this._isMounted) {
			this.setState({reqAnimationFrameTimeout:timeOut})
		}
	}

	componentDidUpdate(prevProps, prevState) {

		if(prevProps.items!==this.props.items) {
			/*so to resize the card sizes and carousel overall height since the items
			 *could have different heights for each card not to mention description/name
			 */
			this.addDataLayer()
			this.reqAnimationFrame(150);
		}

		if (prevProps.exclusivelist !== this.props.exclusivelist) {
			// Update userExclusiveList state when exclusivelist from props changed
			this.setState({userExclusiveList: this.props.exclusivelist ? this.props.exclusivelist : []});
		}

		if (prevState.userExclusiveList !== this.state.userExclusiveList) {
			// Resize card height if "Special Rate" is displayed
			this.reqAnimationFrame(150)
		}
	}

	//resizes the cards to have uniform height and also changes the CarouselProvider height to fit the cards
	findCards = () => {
		if(this._isMounted) {
			let cards
			/* checks just to make sure the component is mounted before doing component related stuff
			 * since this is called by a timeout an async function and component can unmount anytime
		     */
			if(this._isMounted) {
				cards = document.documentElement.getElementsByClassName(`cardCarousel${this.props.header}`)
			}
			let height = 0
			let diff = 0
			if(this._isMounted) { // resets the styles set in place by another earlier instance of this function

				for(let i=0;i<cards.length;i++) {
					cards[i].style.height="initial";
				}
			}

			if(this._isMounted) {
				for( let i=0; i<cards.length;i++) {

					if( !this._isMounted ) {
						break;
					}
					if( height < cards[i].offsetHeight ) {
						height = cards[i].offsetHeight
					}
					/* +10 for just an offset since we have top:5px and an extra 5px is added here just to be sure borders don't get cut
					 * the 100/92 is for the offsetWidth is for the card className to get the full width of the Slide component
					 */
					if( diff < ( (cards[i].offsetHeight+10) / ( cards[i].offsetWidth* (100/92) ) ) ) {
						diff = (cards[i].offsetHeight+10)/ ( cards[i].offsetWidth* (100/92) ) // for the carousel Provider height
					}

				}
			}

			if(this._isMounted) {

				for( let i=0; i<cards.length;i++) {
					if( !this._isMounted ) {
						break;
					}
					cards[i].style.height = `${height}px`
				}
			}

			/*set the heights of the carousel with an offset to make sure carousel has a gap till the next component
				*is also needed to make the component repaint showing the new height.
				*/
			if(this._isMounted) {
				this.setState({ height:diff})
			}
		}
	}



	componentWillUnmount() {
		this._isMounted = false;
		window.removeEventListener('resize', this.resizeConsolidator)
		clearTimeout(this.state.timeOut)
		clearTimeout(this.state.reqAnimationFrameTimeout)

	}


	/* for changing how many are shown in the carousel when browser is resized could be replaced by the
	 * alternative suggested by the semantic ui react team on their upgrade guide from responsive component
	 * https://github.com/Semantic-Org/Semantic-UI-React/pull/4008
	 */
	handler = () => {
		//computer
		if(window.innerWidth > tabletMaxWidth ) {
			if(this._isMounted) {
				this.setState({
					shown : this.props.shown,
					windowWidth:window.innerWidth
				}, ()=>{
					this.reqAnimationFrame(0)
				})
			}

		} //tablet
		else if(window.innerWidth > mobileMaxWidth ){
			if(this._isMounted) {
				this.setState({
					shown:this.props.tabletShown ? this.props.tabletShown:3,
					windowWidth:window.innerWidth
				}, ()=>{
					this.reqAnimationFrame(0)
				})
			}

		} //mobile
		else {
			if(this._isMounted) {
				this.setState({
					shown : this.props.mobileShown ? this.props.mobileShown:2,
					windowWidth:window.innerWidth
				}, ()=>{
					this.reqAnimationFrame(0)
				})
			}

		}
	}

	render() {
		const {
			header,
			items,
			type,
			url,
			itemVar, // For retry function
			loadingVar, // For retry function
			errorVar, // For retry function
			error,
			retryFunc,
			showHeader,
			isItemsLoading,
			handleSlideClick, // For franchise/seminar content
			cardContentClassName, // For blog carousels
			textClassName, // For blog carousels,
			displayOptions = {}
		} = this.props
		const {shown, height, windowWidth, userExclusiveList} = this.state
		const {
			imageSize = "square", 		// "square" | "category" | "blog"
			imagePosition = "top", 		// "top" | "bottom"
			contentBackground = "",		// "" | "green" | "gray"
			contentClassname = "",		// Styling for content container
			showName = false,
			capitalizeName = false,
			maxNameLines = 0,			// integer - number of lines max name lines
			showPrice = true,
			priceClassname = "",		// Styling for price
			showSummary = false,
			maxSummaryLines = 3			// integer - number of lines max summary lines
		} = displayOptions;

		const { space, summarySpace } = StylingTools.getCharacterRowSpaceByWindow(windowWidth, shown);

		let categoryContent
		if(type==="category" || type==="business") {
			if(this.props.categoryClassName) {
				categoryContent= this.props.categoryClassName
			}else {
				categoryContent = styles.categoryContent
			}
		}

		// If items are finished loading and the items are empty, don not render component
		if (!isItemsLoading && items.length === 0){
			return null;
		}

		// Set which items to display based on loading status
		// If loading, create a list of items based on shown state
		let itemsToDisplay = !isItemsLoading ? items : Array.from({length: shown}, () => {
			return {name: "Loading..."}
		}).flat();

		let totalSlides = itemsToDisplay.length;

		return (
			<div className={styles.container} name={`carousel${header.replace(" ", "")}`} ref={this.carouselRef}>
				{showHeader && (
					<Header className={styles.header}>
						{header}
					</Header>
				)}

				{error===true ? (
					<div className={`${styles.text} ${styles.centerText}`}>
						<Button
							icon="redo"
							size="big"
							className={styles.iconButton}
							onClick={()=>{
								retryFunc({url, itemVar, loadingVar, errorVar, type})
							}}
						/>
						<br/><br/>
						Try Again
					</div>
				):(
					<CarouselProvider
						naturalSlideWidth={1}
						naturalSlideHeight={height}
						totalSlides={itemsToDisplay.length}
						visibleSlides={shown}
						infinite={true}
					>
						<Slider className={styles.slider} >
							{ type === "content"
							? items.map(({name, thumbnail, url}, index) => {
								const icon = this.props.icon;
								const iconAndPaddingSpace = 9; // icon (5) + side paddings (2x2 = 4)
								const filenamelink = <div className={contentpagestyles.contentthumbnailname}>
										<span>{StylingTools.getTruncatedString(summarySpace - iconAndPaddingSpace, name, 1)}</span>
										<div><Icon name={handleSlideClick !== null ? icon : "wait"}/></div>
								</div>;

								return <Slide
									index={index}
									key={url}
									className={`${contentpagestyles.contentthumbnail} ${styles.contentSlide}`}
									onClick={handleSlideClick !== null
										? (e) => {
											handleSlideClick(e, url, name)
										}
										: null
									}
								>
									<Card
										className={this.props.className ? `${this.props.className} cardCarousel${header}`:`${styles.card} cardCarousel${header}`}
									>
										<li className={`${contentpagestyles.contentthumbnail} ${handleSlideClick !== null ? '' : contentpagestyles.downloading}`}>
											<ImageHolder
												heightToWidthRatio={1}
												src={thumbnail}
											/>
											{filenamelink}
										</li>
									</Card>
								</Slide>
							})
							: itemsToDisplay.map(({
									name,
									id,
									meta,
									sku,
									url,
									mainImageHref,
									squareImageHref,
									blogImageHref,
									categoryImageHref,
									available,
									price,
									summary,
									exclusive,
									type: itemType
								}, index) => {

								// Choose image source based on image size
								let displayImage = "";
								let imageHeightToWidthRatio = 0; // (Height / Width)

								if (imageSize.trim().length > 0) {
									if (imageSize === "square") {
										displayImage = squareImageHref;
										imageHeightToWidthRatio = 1;
									} else if (imageSize === "blog") {
										// Case: Older API uses squareImageHref as property name regardless of image size
										if (blogImageHref === undefined && squareImageHref !== undefined) {
											displayImage = squareImageHref;
										} else {
											displayImage = blogImageHref;
										}
										imageHeightToWidthRatio = 400 / 600;
									} else if (imageSize === "category") {
										displayImage = categoryImageHref;
										imageHeightToWidthRatio = 400 / 500;
									} else if (imageSize === "promo") {
										displayImage = blogImageHref;
										imageHeightToWidthRatio = 400 / 500;
									}
								}

								if (displayImage === "") {
									totalSlides -= 1;
									return null;
								}

								// Choose appropriate styling for the content section
								let cardContentStyles = ""

								if (contentClassname.trim().length > 0) {
									cardContentStyles = contentClassname;
								} else if (contentBackground === "green") {
									cardContentStyles = styles.categoryContent;
								} else if (contentBackground === "gray") {
									cardContentStyles = styles.blogContent;
								}

								// Header/name to be displayed
								let displayName = "";

								// Truncate name based on number of lines
								if (showName && name !== undefined) {
									if (maxNameLines > 0) {
										displayName = StylingTools.getTruncatedString(space, name, maxNameLines);
									} else {
										displayName = name;
									}
								}


								let pricestr = "0.00"
								var priceval = 0;
								if(meta) {
									if (price !== undefined) {
										priceval = parseFloat(price)
										pricestr = `${priceval.toFixed(2)}`
									} else {
										pricestr = meta.display_price.with_tax.formatted
										priceval = parseFloat(meta.display_price.with_tax.amount)
									}
								}

								let exclusivestr = "0.00";
								let exclusiveval = 0;

								if (exclusive === undefined) {
									exclusive = []
								}

								if (meta !== undefined) {
									if (meta.hasOwnProperty("exclusive")) {
										exclusive = meta.exclusive;
									}
								}

								// Checks if user has registered to any franchise, seminar, course.
								if (userExclusiveList.length > 0 && exclusive !== undefined ) {
									// Checks if product has special rates
									if (exclusive.length > 0) {
										// Filter the special rates applicable to the user
										const applicablePrices = exclusive.filter((e) => {
											return userExclusiveList.includes(e.code);
										})

										// Checks if there are any applicable special rates
										if (applicablePrices.length > 0) {
											let lowestApplicablePrice = applicablePrices[0].price;

											// Find the lowest price among the applicable special rates
											for (const applicablePrice of applicablePrices) {
												if (applicablePrice < lowestApplicablePrice) {
													lowestApplicablePrice = applicablePrice.price;
												}
											}

											// Set the exclusive price to be the lowest applicable special rate
											exclusiveval = lowestApplicablePrice;
										}

										// Format exclusive/special rate
										if (exclusiveval > 0) exclusivestr = `${exclusiveval.toFixed(2)}`;
									}
								}

								// Summary to be displayed
								let displaySummary = "";

								// Truncate summary based on the number of lines
								if (showSummary && summary !== undefined) {
									if (maxSummaryLines > 0) {
										displaySummary = StylingTools.getTruncatedString(summarySpace, summary, maxSummaryLines);
									} else {
										displaySummary = summary;
									}
								}

								let cardProps = {}
								if(!this.props.isItemsLoading) {
									cardProps.as = Link
									cardProps.to= `/${url}/`
									if(type==="product" || itemType === "product") {
										cardProps.state={
											cameFrom:`carousel-${header}`,
											index:index+1
										}
									}
								}
								return (
									<Slide
										index={index}
										key={ (type==="category" || type==="business") ? url : id}
									>
										<Card
											{...cardProps}
											className={this.props.className ? `${this.props.className} cardCarousel${header}`:`${styles.card} cardCarousel${header}`}
											onMouseDown={(e) => {
												// Fires on Desktop only
												this.mouseMovement.current = {
													startX: e.clientX, startY: e.clientY, 
													endX: e.clientX, endY: e.clientY
												}
											}}
											onMouseUp={(e) => {
												// Fires on Desktop only; when released within carousel component
												this.mouseMovement.current.endX = e.clientX;
												this.mouseMovement.current.endY = e.clientY;
											}}
											onClick={(e)=>{
												// Fires Mobile and Desktop (after mouse up, when w/in carousel compponent)
												e.preventDefault();
												const distanceX = Math.abs(this.mouseMovement.current.startX - this.mouseMovement.current.endX)
												const distanceY = Math.abs(this.mouseMovement.current.startY - this.mouseMovement.current.endY)

												// 5% of the Carousel width
												const threshold = this.carouselRef.current.offsetWidth * 0.05;

												if (distanceX < threshold && distanceY < threshold) {
													if(type==="product" || itemType === "product") {
														window.dataLayer = window.dataLayer || [];
														window.dataLayer.push({
															'event':'productClick',
															'ecommerce': {
																'click': {
																	'actionField': {'list':this.props.listName},
																	'products': [{
																		'name':name,
																		'id': sku ?? meta.sku,
																		'price':priceval,
																		'position':index+1,
																		'item_id': sku ?? meta.sku,
																		'item_name': name,
																		'currency': "PHP",
																		'index': index+1,
																		'item_list_id': this.props.listName,
																		'item_list_name': this.props.listName,
																		'quantity': 1
																	}]
																}
															}
														});
													}

													if(!this.props.isItemsLoading) {
														let cardState = {};

														if(type==="product" || itemType === "product") {
															cardState = { cameFrom:`carousel-${header}`, index: index + 1 }
														}

														navigate(`/${url}/`, {state: cardState});
													}
												}
											}}
										>
											{ imagePosition === "top" &&
												<ImageHolder
													heightToWidthRatio={imageHeightToWidthRatio}
													src={displayImage ?? mainImageHref}
													alt={name}
													displayMode={isItemsLoading ? "loading" : "default"}
												/>
											}
											{(showName || showPrice || showSummary) &&
												<Card.Content className={cardContentStyles}>
													{ showName &&
														<Card.Header className={
															contentBackground === "green"
															? styles.categoryHeader
															: capitalizeName ? styles.productHeader : ''
														}>
															{displayName}
														</Card.Header>
													}
													{ showPrice && <>
														{(priceval > 0 || exclusiveval > 0)  &&
															<Card.Meta className={`${styles.meta} ${priceClassname}`}>
																{ exclusiveval > 0
																	? <>
																		{priceval > 0 && <s>{pricestr}</s>}
																		<span>{exclusivestr}</span>
																	</>
																	: <span>{pricestr}</span>
																}
															</Card.Meta>
														}
													{exclusiveval > 0 ?
														<Card.Description>
															<div className={`${styles.meta} ${priceClassname} ${styles.warningMessage}`}>
																Special Rate
															</div>
														</Card.Description>
													: available===false &&
														<Card.Description className={styles.warningMessage}>
															{priceval>0 ?
																"Product no longer available"
															:
																"Exclusive Item"
															}
														</Card.Description>
													}
													</>}
													{(showSummary && displaySummary.trim().length > 0) &&
														<Card.Description className={textClassName ? textClassName : styles.blogText}>
															{displaySummary}
														</Card.Description>
													}

												</Card.Content>
											}
											{ imagePosition === "bottom" &&
												<ImageHolder
													heightToWidthRatio={imageHeightToWidthRatio}
													src={displayImage ?? mainImageHref}
													alt={name}
													displayMode={isItemsLoading ? "loading" : "default"}
												/>
											}
										</Card>
									</Slide>
								)
							})
						}
						</Slider>
						{shown < totalSlides && (
							<React.Fragment>
								<ButtonBack
									className={`${styles.buttonBack} ${styles.navButton}`}
								>
									{`<`}
								</ButtonBack>
								<ButtonNext
									className={`${styles.buttonNext} ${styles.navButton}`}
								>
									{`>`}
								</ButtonNext>
							</React.Fragment>
						)}
					</CarouselProvider>
				)}
			</div>
		)
	}
}
export default Carousel

Carousel.defaultProps = {
	showHeader:true, //to show the Header component, can't just pass no Header to this component or else ALL(not just the ones in carousel) the semantic ui react card is gotten by the getElementsByClassName
	isItemsLoading: false
}